// extracted by mini-css-extract-plugin
module.exports = {"popup-wrapper":"popup-wrapper--3C0bY","popupWrapper":"popup-wrapper--3C0bY","popup-component":"popup-component--3qKQZ","popupComponent":"popup-component--3qKQZ"};